import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getProfile, getUserupdated } from "../../Api/AffiliateApiCall";

export const fetchgetProfileApi = createAsyncThunk(
    "affiliate/fetchgetProfileApi",
    async (_, { rejectWithValue }) => {
        try {
            const res = await getProfile();
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Failed to load dashboard"
            );
        }
    }
);

export const fetchgetuserupdatedApi = createAsyncThunk(
    "affiliate/fetchgetuserupdatedApi",
    async (payload, { rejectWithValue }) => {
        try {
            const res = await getUserupdated(payload);
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Failed to load dashboard"
            );
        }
    }
);

// getUserupdated

const AffiliateProfileSlice = createSlice({
    name: "AffiliateProfile",
    initialState: {
        Profiledata: [],
        userupdatedata:[],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchgetProfileApi.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchgetProfileApi.fulfilled, (state, action) => {
                state.loading = false;
                state.Profiledata = action.payload;
            })
            .addCase(fetchgetProfileApi.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

             .addCase(fetchgetuserupdatedApi.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchgetuserupdatedApi.fulfilled, (state, action) => {
                state.loading = false;
                state.userupdatedata = action.payload;
            })
            .addCase(fetchgetuserupdatedApi.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // fetchgetuserupdatedApi
    },
});

const AffiliateProfileSliceReducer = AffiliateProfileSlice.reducer;

export default AffiliateProfileSliceReducer;
